{
  "app": {
    "title": "Siete Maravillas",
    "tagline": "Construye tu ciudad. Erige tu maravilla. Supera a tus vecinos."
  },
  "name": {
    "label": "¿Cómo te llamas?",
    "placeholder": "Tu nombre",
    "enter": "Entrar",
    "hint": "Sin contraseña: tu sesión queda guardada en este navegador.",
    "inUse": "«{{name}}» está conectado en otro navegador.",
    "takeover": "Tomar el control aquí",
    "change": "Cambiar de nombre"
  },
  "home": {
    "greeting": "Hola, {{name}}",
    "create": "Crear sala",
    "createHint": "Invita a tus amigos con un código.",
    "join": "Unirse",
    "joinPlaceholder": "Código de sala",
    "publicRooms": "Salas públicas",
    "noPublicRooms": "No hay salas públicas abiertas ahora mismo.",
    "history": "Mi historial",
    "rules": "Reglas y cartas",
    "backToRoom": "Volver a mi sala ({{code}})",
    "players": "{{count}} jugadores",
    "host": "Anfitrión: {{name}}"
  },
  "conn": {
    "connecting": "Conectando…",
    "reconnecting": "Reconectando con el servidor…",
    "replaced": "Tu sesión se abrió en otra pestaña o dispositivo.",
    "useHere": "Usar aquí",
    "upgrade": "Hay una versión nueva del juego.",
    "reload": "Recargar"
  },
  "lobby": {
    "room": "Sala",
    "share": "Comparte el código o el enlace",
    "copyLink": "Copiar enlace",
    "copied": "¡Enlace copiado!",
    "players": "Jugadores ({{count}}/7)",
    "spectators": "Espectadores",
    "host": "Anfitrión",
    "you": "tú",
    "disconnected": "desconectado",
    "kick": "Expulsar",
    "makeHost": "Hacer anfitrión",
    "start": "Comenzar partida",
    "needPlayers": "Se necesitan entre 3 y 7 jugadores",
    "waitingHost": "Esperando a que el anfitrión comience…",
    "leave": "Salir de la sala",
    "settings": "Opciones de la partida",
    "wonderMode": "Maravillas",
    "wonderMode_random": "Al azar",
    "wonderMode_choose": "Cada uno elige",
    "sidePolicy": "Lado del tablero",
    "sidePolicy_choose": "Cada uno elige",
    "sidePolicy_day": "Todos Día",
    "sidePolicy_night": "Todos Noche",
    "sidePolicy_random": "Al azar",
    "seating": "Asientos",
    "seating_random": "Al azar",
    "seating_lobbyOrder": "Orden de llegada",
    "visibility": "Visibilidad",
    "visibility_private": "Privada (solo con código)",
    "visibility_public": "Pública",
    "pickWonder": "Elige tu maravilla",
    "taken": "elegida por {{name}}",
    "noPick": "Al azar",
    "backToGame": "Ir a la partida"
  },
  "game": {
    "age": "Era {{age}}",
    "turn": "Turno {{turn}}/6",
    "passLeft": "Las cartas pasan a la izquierda",
    "passRight": "Las cartas pasan a la derecha",
    "discardPile": "Descarte: {{count}}",
    "yourHand": "Tu mano",
    "chooseCard": "Elige una carta",
    "chosen": "Elegida",
    "change": "Cambiar",
    "waitingFor": "Esperando a: {{names}}",
    "waitingAll": "Todos eligieron. Resolviendo…",
    "youChose": "Elegiste. Esperando al resto de la mesa.",
    "specialWaiting": "{{name}} está resolviendo «{{what}}»…",
    "special_buildFromDiscard": "Construir del descarte",
    "special_playLastCard": "Jugar la 7ª carta",
    "disconnectedFor": "desconectado {{time}}",
    "retire": "Retirar",
    "retireIn": "podrás retirarlo en {{time}}",
    "retireConfirm": "¿Retirar a {{name}}? Su ciudad quedará congelada el resto de la partida.",
    "abandon": "Abandonar partida",
    "abandonConfirm": "Tu ciudad quedará congelada: seguirá en la mesa (tus vecinos podrán comprarte recursos y cuenta en lo militar), pero ya no jugarás. No se puede deshacer.",
    "abandonYes": "Sí, abandonar",
    "cancel": "Cancelar",
    "frozen": "Abandonó",
    "frozenRetired": "Retirado",
    "left": "Izquierda",
    "right": "Derecha",
    "me": "Tú",
    "coins": "Monedas",
    "shields": "Escudos",
    "military": "Militar",
    "cards": "Cartas",
    "wonder": "Maravilla",
    "stage": "Etapa {{n}}",
    "stageBuilt": "Construida",
    "canBuy": "Puedes comprarle",
    "price": "a {{price}}",
    "nothingToBuy": "Nada que comprar",
    "production": "Producción",
    "science": "Ciencia",
    "viewCity": "Ver ciudad",
    "spectating": "Estás mirando la partida",
    "sideSelection": "Elige el lado de tu maravilla",
    "sideWaiting": "Esperando a que todos elijan lado…",
    "chooseThisSide": "Elegir lado {{side}}",
    "halikarnassosTitle": "Construye gratis una carta del descarte",
    "halikarnassosHint": "Efecto de tu maravilla: elige una carta del descarte y constrúyela sin pagar.",
    "babylonTitle": "Juega tu 7ª carta",
    "babylonHint": "Efecto de tu maravilla: puedes jugar la última carta de la era como un turno extra.",
    "ageEnd": "Fin de la Era {{age}}",
    "militaryConflicts": "Conflictos militares",
    "victory": "Victoria",
    "defeat": "Derrota",
    "tie": "Empate",
    "gameOver": "Fin de la partida",
    "abandonedEnd": "La partida terminó: quedan menos de 2 jugadores activos.",
    "backToLobby": "Revancha (volver a la sala)",
    "exit": "Salir",
    "results": "Resultados",
    "menu": "Menú",
    "rules": "Reglas",
    "settings": "Ajustes",
    "chat": "Chat",
    "you": "tú",
    "view3d": "Mesa 3D",
    "view2d": "Vista 2D",
    "lastPlays": "Última ronda",
    "yourTurnCard": "¡Te toca! Elige una carta",
    "yourTurnSide": "¡Te toca! Elige el lado de tu maravilla",
    "status_yourTurn": "¡Te toca!",
    "status_choosing": "Eligiendo…",
    "status_ready": "Listo",
    "status_frozen": "Congelada",
    "status_acting": "Jugando…",
    "youChoseShort": "✓ Elegiste",
    "tradeTipOne": "Te vende 1 de {{what}} por {{price}}.",
    "tradeTipMany": "Te vende hasta {{n}} de {{what}}, por {{price}} cada una.",
    "tradeChoice": "(a elegir)",
    "coinCount_one": "{{count}} moneda",
    "coinCount_other": "{{count}} monedas"
  },
  "actions": {
    "build": "Construir",
    "wonder": "Construir etapa {{n}}",
    "discard": "Vender",
    "discardHint": "+{{coins}} monedas",
    "free": "Gratis",
    "freeReason_chain": "Gratis por encadenamiento",
    "freeReason_freeFirstOfColor": "Gratis: primera de su color (Olimpia)",
    "freeReason_freeFirstOfAge": "Gratis: primera de la era (Olimpia)",
    "freeReason_freeLastOfAge": "Gratis: última de la era (Olimpia)",
    "noCost": "Sin coste",
    "pay": "Pagas {{total}}",
    "payBank": "{{coins}} al banco",
    "payLeft": "{{coins}} a {{name}} (izq.)",
    "payRight": "{{coins}} a {{name}} (der.)",
    "buyFrom": "Compras {{what}} a {{name}}",
    "otherOptions": "Otras formas de pagar ({{count}})",
    "confirm": "Confirmar",
    "blocked_DUPLICATE_BUILDING": "Ya lo tienes",
    "blocked_NO_RESOURCES": "Faltan recursos",
    "blocked_NOT_ENOUGH_COINS": "Faltan monedas",
    "blocked_WONDER_COMPLETE": "Maravilla completa",
    "blocked_NO_SIDE": "Sin lado elegido",
    "selectCardFirst": "Elige una carta de tu mano"
  },
  "notices": {
    "HOST_MIGRATED": "{{name}} es ahora el anfitrión.",
    "PLAYER_FROZEN": "Un jugador abandonó.",
    "PLAYER_RETIRED": "Un jugador fue retirado.",
    "YOU_WERE_RETIRED": "El anfitrión te retiró de la partida por estar desconectado.",
    "YOU_WERE_KICKED": "El anfitrión te sacó de la sala.",
    "ROOM_CLOSED": "La sala {{code}} se cerró.",
    "GAME_ABORTED": "La partida se canceló por inactividad."
  },
  "system": {
    "ROOM_CREATED": "{{name}} creó la sala.",
    "PLAYER_JOINED": "{{name}} se unió.",
    "SPECTATOR_JOINED": "{{name}} está mirando.",
    "PLAYER_LEFT": "{{name}} salió de la sala.",
    "PLAYER_KICKED": "{{name}} fue expulsado.",
    "HOST_CHANGED": "{{name}} es el nuevo anfitrión.",
    "HOST_MIGRATED": "{{name}} es el nuevo anfitrión.",
    "GAME_STARTED": "¡Comienza la partida!",
    "GAME_OVER": "La partida terminó.",
    "BACK_TO_LOBBY": "De vuelta en la sala.",
    "PLAYER_ABANDONED": "{{name}} abandonó: su ciudad queda congelada.",
    "PLAYER_RETIRED": "{{name}} fue retirado: su ciudad queda congelada."
  },
  "chat": {
    "title": "Chat",
    "placeholder": "Escribe un mensaje…",
    "send": "Enviar",
    "empty": "Aún no hay mensajes."
  },
  "emotes": {
    "thumbs": "👍",
    "laugh": "😂",
    "wow": "😮",
    "angry": "😠",
    "think": "🤔",
    "clap": "👏",
    "cry": "😢",
    "fire": "🔥",
    "swords": "⚔️",
    "crown": "👑"
  },
  "score": {
    "military": "Militar",
    "treasury": "Tesoro",
    "wonder": "Maravilla",
    "civil": "Civiles",
    "science": "Ciencia",
    "commercial": "Comercio",
    "guilds": "Gremios",
    "total": "Total",
    "rank": "Puesto",
    "winner": "¡{{name}} gana!",
    "winners": "Victoria compartida: {{names}}",
    "forfeit": "{{name}} gana por abandono",
    "abandoned": "abandonó",
    "coinsTiebreak": "Desempate por monedas"
  },
  "settings": {
    "title": "Ajustes",
    "audio": "Sonido",
    "master": "Volumen general",
    "music": "Música",
    "sfx": "Efectos",
    "mute": "Silenciar",
    "graphics": "Gráficos",
    "render": "Vista de la mesa",
    "render_auto": "Automática",
    "render_3d": "Mesa 3D",
    "render_2d": "2D (ligera)",
    "quality": "Calidad",
    "quality_auto": "Automática",
    "quality_low": "Baja",
    "quality_medium": "Media",
    "quality_high": "Alta",
    "reducedMotion": "Reducir animaciones",
    "close": "Cerrar"
  },
  "stats": {
    "title": "Estadísticas de {{name}}",
    "played": "Partidas",
    "wins": "Victorias",
    "winRate": "% victorias",
    "avg": "Media",
    "best": "Mejor",
    "abandoned": "Abandonadas",
    "byWonder": "Por maravilla",
    "recent": "Partidas recientes",
    "none": "Todavía no hay partidas terminadas.",
    "avgByCategory": "Media por categoría",
    "back": "Volver"
  },
  "common": {
    "back": "Volver",
    "close": "Cerrar",
    "loading": "Cargando…",
    "notFound": "No encontramos esta página.",
    "goHome": "Ir al inicio",
    "yes": "Sí",
    "no": "No"
  },
  "inspect": {
    "title": "En esta partida",
    "open": "Ver detalle",
    "openCard": "Ver detalle de {{name}}",
    "hint": "Clic derecho o mantén pulsada una carta para ver su detalle.",
    "canBuildFree": "Puedes construirla gratis",
    "chainedBy": "Encadena con tu {{card}}.",
    "canBuild": "Puedes construirla",
    "ownProduction": "Te alcanza con tu propia producción: no pagas nada.",
    "cheapest": "La forma más barata:",
    "moreOptions": "Hay {{count}} formas de pagar: eliges cuál al construir.",
    "cannotBuild": "No puedes construirla",
    "duplicate": "Ya tienes una carta con este nombre en tu ciudad, y no se pueden repetir.",
    "noResources": "Ni con tu producción ni comprando a tus vecinos te alcanzan los recursos.",
    "missing": "Te falta: {{what}}.",
    "noCoins": "Te faltan monedas: construirla cuesta {{total}} y tienes {{coins}}.",
    "noCoinsGeneric": "Te faltan monedas para comprar lo que necesitas.",
    "sell": "Si la vendes, ganas {{coins}} monedas.",
    "wonder": "También puedes ponerla boca abajo para construir una etapa de tu maravilla, si puedes pagar su coste.",
    "unlocksHand": "Si la construyes, más adelante podrás construir gratis: {{cards}}.",
    "notInHand": "Esta carta ya no está en tu mano.",
    "mine": "Ya está en tu ciudad.",
    "unlocksMine": "Gracias a ella puedes construir gratis: {{cards}}.",
    "owner_left": "Es de {{name}}, tu vecino de la izquierda.",
    "owner_right": "Es de {{name}}, tu vecino de la derecha.",
    "owner_other": "Es de {{name}}. No es tu vecino: no puedes comprarle recursos.",
    "sells": "Mientras la tenga, cada turno te puede vender:",
    "sellsNothing": "Esta carta no produce nada que le puedas comprar.",
    "or": "o"
  },
  "wonderStage": {
    "title": "Etapa {{n}} · {{wonder}} ({{side}})",
    "yours": "Tu maravilla",
    "of": "Maravilla de {{name}}",
    "preview": "Vista previa del lado {{side}}",
    "built": "Activa",
    "builtAt": "construida en la Era {{age}}, ronda {{turn}}",
    "builtAtLast": "construida en la Era {{age}} con la 7.ª carta",
    "next": "Próxima",
    "nextHint": "es la siguiente que puede construir",
    "locked": "Bloqueada",
    "lockedHint": "antes hay que construir la etapa {{n}}",
    "cost": "Coste",
    "free": "Sin coste",
    "timing_immediate": "Al construirla (una sola vez)",
    "timing_ongoing": "Mientras la tenga",
    "timing_endgame": "Al final de la partida",
    "nothing": "Esta etapa no da nada en este momento.",
    "canBuild": "Puedes construirla ahora",
    "canBuildHow": "Pon boca abajo cualquier carta de tu mano y elige «Construir etapa».",
    "cannotBuild": "Todavía no puedes construirla",
    "howToPay": "La forma más barata:",
    "ownProduction": "Te alcanza con tu propia producción: no pagas nada.",
    "summaryMine": "Tu maravilla ya te da:",
    "summaryOf": "Su maravilla ya le da:",
    "summaryNone": "Aún no hay etapas construidas.",
    "shields": "+{{n}} escudos",
    "vpEnd": "{{n}} PV al final",
    "openStage": "Ver la etapa {{n}}",
    "toastYou": "Construiste la etapa {{n}} de {{wonder}}: {{what}}",
    "toastOther": "{{name}} construyó la etapa {{n}} de {{wonder}}: {{what}}",
    "short_vp": "+{{n}} PV al final",
    "short_shields": "+{{n}} escudos",
    "short_coins": "+{{n}} monedas",
    "short_produce": "produce {{what}}",
    "short_buildFromDiscard": "construye gratis una carta del descarte",
    "short_playLastCard": "puede jugar su 7.ª carta de cada era",
    "short_freeFirstOfColor": "la 1.ª carta de cada color le sale gratis",
    "short_freeFirstOfAge": "la 1.ª carta de cada era le sale gratis",
    "short_freeLastOfAge": "la última carta de cada era le sale gratis",
    "short_science": "un símbolo de ciencia",
    "short_scienceWild": "un símbolo de ciencia comodín",
    "short_tradePrice": "compra más barato a sus vecinos",
    "short_vpIfWonderComplete": "+{{n}} PV si completa la maravilla"
  }
}
